import React, { useState } from 'react';
import './index.css';
import SearchFilter from '../../../components/Portfolio/SearchFilter';
// import unassignedTableData from '../../../constant/unassignedTable';
import Table from '../../../components/Common/Table';
import Pagination from '../../../components/Pagination';
import Button from '../../../components/Common/Button';
import { productType } from '../../../constant/selectOptions';
import { eligibleForLender } from '../../../constant/selectOptions';
import { productName } from '../../../constant/selectOptions';
import PortfolioContainer from '../../../components/Portfolio/PortfolioContainer';
import LenderUgroService from '../../../services/lender';
import { Context } from '../../../config/store';
import TableNoRecords from '../../../components/Common/Table/TableNoRecords';
import portfolio from '../../../constant/tableHeaders/portfolio';
import { downloadFile } from '../../../common/download';
import { useNavigate } from 'react-router';
import objectToQueryParams from '../../../common/objectToQueryParams';

function PreApproved() {

	let sessionStorageData = JSON.parse(sessionStorage.getItem('searchData')) || {};
	let { org_page = 1 } = sessionStorageData;
	const queryString = objectToQueryParams(sessionStorageData);
	const [queryParams, setQueryParams] = React.useState(queryString);
	const [page, setCurrentPage] = useState(org_page);
	const [tableData, setTableData] = useState({
		columns: portfolio,
		rows: [],
	});
	const [pagination, setPagination] = useState({});
	const [loading, setLoading] = React.useState(true);
	const [sortParams, setSortParams] = React.useState({
		sortBy: '',
		sortOrder: '',
	});
	const [excelLoader, setExcelLoader] = useState(false)
	const { state, dispatch } = React.useContext(Context);
	const navigate = useNavigate();
	const [isSearch, setIsSearch] = useState(false)
	const [isSubmitClicked, setIsSubmitClicked] = React.useState(false)

	const getPortfolio = async (paramsChanged, sortOrder, sortBy) => {
		setLoading(true);
		const response = await LenderUgroService.getAdminFilteredPortfolio({
			type: state.userType,
			page: paramsChanged ? 1 : page,
			leadType: 'lender-preapproved',
			dataExport: 0,
			sortBy: sortBy ? sortBy : sortParams.sortBy,
			sortOrder: sortOrder ? sortOrder : sortParams.sortOrder,

			queryParams,
		});
		const data = response.data.data?.cl_leads;
		setTableData({
			...tableData,
			rows: data?.data || [],
		});

		setCurrentPage(page);
		// Update session storage data if page changed
		let searchDataNew = { ...sessionStorageData, org_page: (paramsChanged ? 1 : page) }
		sessionStorage.setItem('searchData', JSON.stringify(searchDataNew))
		setPagination(response?.data?.data.cl_leads.pagination);
		setLoading(false);
	};
	const onSortChange = ({ sortOrder, sortBy }) => {
		setSortParams({ sortBy, sortOrder });
		getPortfolio(false, sortOrder, sortBy);
	};
	const exportLead = async () => {
		setExcelLoader(true)
		const response = await LenderUgroService.getAdminFilteredPortfolio({
			type: state.userType,
			page,
			leadType: 'lender-preapproved',
			dataExport: 1,
			queryParams,
			sortBy: sortParams.sortBy,
			sortOrder: sortParams.sortOrder,
			responseType: 'blob',
		});
		downloadFile(response.data, 'lender_sanctioned' + +new Date());
		setExcelLoader(false)
	};

	const redirectToDetails = (leadId) => {
		navigate('/portfolio/view/' + leadId + '/details');
	};

	React.useEffect(() => {
		getPortfolio();
	}, [page]);
	React.useEffect(() => {
		if (!loading) getPortfolio(true);
	}, [queryParams]);
	React.useEffect(() => {
		dispatch({
			type: 'selectedColender',
			selectedColender: '/portfolio/pre-approved',
		});
		localStorage.setItem('selectedColender', '/portfolio/pre-approved');
	}, []);

	return (
		<PortfolioContainer>
			<SearchFilter
				setQueryParams={setQueryParams}
				productTypes={productType}
				productNames={productName}
				lenders={eligibleForLender}
				loading={loading}
			></SearchFilter>
			<div className='d-flex justify-content-end'>
				{excelLoader ? <Button classNames='excelDownloadLoader my-3'> <div className="loader"></div></Button> :
					<Button
						type='btn-export'
						classNames='float-right text-white mt-2 mb-2'
						clickHandler={exportLead}
					>
						<i class="fa fa-file-excel-o mr-1" aria-hidden="true"></i>
						Export Excel
					</Button>
				}
			</div>
			<div className="pre_approve">
				<Table
					checkbox={false}
					columns={tableData.columns}
					rows={tableData.rows}
					loading={loading}
					onSortChange={onSortChange}
					reloadTable={redirectToDetails}
				>
					{Boolean(!tableData.rows.length && !loading) && <TableNoRecords />}
				</Table>
			</div>
			<div className="my-2">
				{pagination?.total_pages ? (
					<Pagination
						disabled={loading}
						setPage={setCurrentPage}
						total_pages={pagination.total_pages}
						total={pagination.total}
						showTotal={true}
					/>
				) : (
					''
				)}
			</div>
		</PortfolioContainer>
	);
}

export default PreApproved;
